"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Score_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Score"));
const MetricRankTag_vue_1 = __importDefault(require("./MetricRankTag.vue"));
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
let MetricItem = class MetricItem extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get isDifferenceShown() {
        if (this.isMainPanel) {
            if ('baseMetric' in this.currentMetric) {
                return true;
            }
        }
        return false;
    }
    get higherInMain() {
        return ('higherIn' in this.currentMetric) ?
            this.currentMetric.higherIn === 'main' : false;
    }
    get higherInThisPanel() {
        return ('higherIn' in this.currentMetric) ?
            (this.currentMetric.higherIn === 'main' && this.isMainPanel) ||
                (this.currentMetric.higherIn === 'secondary' && !this.isMainPanel) : false;
    }
    get metricName() {
        return ('baseMetric' in this.currentMetric) ?
            this.currentMetric.baseMetric.name :
            this.currentMetric.name;
    }
    get metricSurname() {
        return ('baseMetric' in this.currentMetric) ?
            ('test_name' in this.currentMetric.baseMetric) ?
                this.currentMetric.baseMetric.test_name :
                (0, trans_1.trans)('results_view_map.categories.' + this.currentMetric.baseMetric.category)
            :
                ('test_name' in this.currentMetric) ?
                    this.currentMetric.test_name :
                    (0, trans_1.trans)('results_view_map.categories.' + this.currentMetric.category);
    }
    get metricScore() {
        let score = 0;
        if (this.type === 'farm') {
            if ('baseMetric' in this.currentMetric) {
                if (this.higherInThisPanel) {
                    if ('scoreBC' in this.currentMetric.baseMetric) {
                        score = this.currentMetric.baseMetric.scoreBC.value;
                    }
                    else {
                        score = Math.round(this.currentMetric.baseMetric.score * 100) / 100;
                    }
                }
                else {
                    score = Math.round(this.currentMetric.scoreDefeated.value * 100) / 100;
                }
            }
            else {
                //console.log('simple')
                if ('scoreBC' in this.currentMetric) {
                    //console.log('bio')
                    score = this.currentMetric.scoreBC.value;
                }
                else {
                    //console.log('phch')
                    score = Math.round(this.currentMetric.score * 100) / 100;
                }
            }
        }
        else {
            if ('baseMetric' in this.currentMetric) {
                //console.log('vs')
                if (this.higherInThisPanel) {
                    if ('scoreBC' in this.currentMetric.baseMetric) {
                        score = this.currentMetric.baseMetric.scoreBC.value;
                    }
                    else {
                        score = Math.round(this.currentMetric.baseMetric.score * 100) / 100;
                    }
                }
                else {
                    score = Math.round(this.currentMetric.scoreDefeated.value * 100) / 100;
                }
            }
            else {
                if ('scoreBC' in this.currentMetric) {
                    //console.log('bio')
                    score = this.currentMetric.scoreBC.value;
                }
                else {
                    //console.log('phch')
                    score = Math.round(this.currentMetric.score * 100) / 100;
                }
            }
        }
        if (score < 0)
            score = 0;
        if ('scoreBC' in this.currentMetric) {
            score = new Score_1.default(score, '').value;
        }
        return score;
    }
    /*
        OLD ONE
        get metricScore() {
            if(this.type === 'farm'){
                if('baseMetric' in this.currentMetric) {
                    if(this.higherInThisPanel) {
                        if('scoreBC' in this.currentMetric.baseMetric) {
                            score = this.currentMetric.baseMetric.scoreBC.value
                        } else {
                            score = Math.round(this.currentMetric.baseMetric.score * 100) / 100
                        }
                    } else {
                        score =  Math.round(this.currentMetric.scoreDefeated.value * 100) / 100
                    }
                } else {
                    //console.log('simple')
                    if (this.currentField.isValid()) {
                        //console.log('es field')
                        score = this.currentField.getMetricValue(this.currentMetric.code_name);
                        if(score > 0 && score < 1) score = 1
                        score = Math.round(score * 100) / 100 ;
                        score = new Score(score, '').value
                    } else {
                        if('scoreBC' in this.currentMetric) {
                            //console.log('bio')
                            score = this.currentMetric.scoreBC.value
                        } else {
                            //console.log('phch')
                            score = Math.round(this.currentMetric.score * 100) / 100
                        }
                    }
                }
            } else {
                if(this.currentZone){
                    if(this.currentZone?.get('avg')! > 0){
                        score = this.currentZone?.get('avg')!
                    }
                } else {
                    if('baseMetric' in this.currentMetric) {
                        //console.log('vs')
                        if(this.higherInThisPanel) {
                            if('scoreBC' in this.currentMetric.baseMetric) {
                                score = this.currentMetric.baseMetric.scoreBC.value
                            } else {
                                score = Math.round(this.currentMetric.baseMetric.score * 100) / 100
                            }
                        } else {
                            score =  Math.round(this.currentMetric.scoreDefeated.value * 100) / 100
                        }
                    } else {
                        if('scoreBC' in this.currentMetric) {
                            //console.log('bio')
                            score = this.currentMetric.scoreBC.value
                        } else {
                            //console.log('phch')
                            score = Math.round(this.currentMetric.score * 100) / 100
                        }
                    }
                }
            }
    
            if(score < 0) score = 0
            if('scoreBC' in this.currentMetric) {
                score = new Score(score, '').value
            }
            return score
        } */
    get metricScale() {
        let scale = 'std';
        if ('baseMetric' in this.currentMetric) {
            if ('scale' in this.currentMetric.baseMetric) {
                scale = this.currentMetric.baseMetric.scale;
            }
        }
        else {
            if ('scale' in this.currentMetric) {
                scale = this.currentMetric.scale;
            }
        }
        return scale;
    }
    get metricUnit() {
        let unit = '';
        if (this.metricScore === -1)
            return '404';
        if ('baseMetric' in this.currentMetric) {
            if ('unit' in this.currentMetric.baseMetric) {
                unit = this.currentMetric.baseMetric.unit;
            }
        }
        else {
            if ('unit' in this.currentMetric) {
                unit = this.currentMetric.unit;
            }
        }
        return unit;
    }
    get hasRanks() {
        let ranks = false;
        if ('baseMetric' in this.currentMetric) {
            if (this.higherInThisPanel) {
                if (this.currentMetric.baseMetric.rank > 0)
                    ranks = true;
            }
            else {
                if (this.currentMetric.rankDefeated > 0)
                    ranks = true;
            }
        }
        else {
            if ('scoreBC' in this.currentMetric) {
                if (this.currentMetric.rank > 0)
                    ranks = true;
            }
        }
        return ranks;
    }
    loadPreviousMetric() {
        this.$emit('loadPreviousMetric');
    }
    loadNextMetric() {
        this.$emit('loadNextMetric');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MetricItem.prototype, "currentMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new Recommendations_1.FieldRecommendation({}, []) })
], MetricItem.prototype, "currentField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], MetricItem.prototype, "isMainPanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], MetricItem.prototype, "hasAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], MetricItem.prototype, "hasInteraction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MetricItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MetricItem.prototype, "currentZone", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricItem.prototype, "type", void 0);
MetricItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MetricRankTag: MetricRankTag_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            ChevronUp: lucide_vue_next_1.ChevronUp,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            ArrowUp: lucide_vue_next_1.ArrowUp,
            ArrowDown: lucide_vue_next_1.ArrowDown
        },
    })
], MetricItem);
exports.default = MetricItem;
